<template>
  <div>
    <h4 class="ui dividing header">{{ $t("setup") }}</h4>
    <div class="field">
      <label for="">{{ $t("api url") }}</label>
      <input type="text" name="api_url" v-model="setup.api_url" />
    </div>
    <div class="three fields">
      <div class="field">
        <label for="">{{ $t("campaign") }}</label>
        <input type="text" name="campaign" v-model="setup.campaign" />
      </div>
      <div class="field">
        <label for="">{{ $t("agent") }}</label>
        <input type="text" name="agent" v-model="setup.agent" />
      </div>
      <div class="field">
        <label for="">{{ $t("source") }}</label>
        <input type="text" name="source" v-model="setup.source" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GrupoGente",
  data() {
    return {
      setup: {
        api_url: "",
        campaign: "",
        agent: "",
        source: "",
      },
    };
  },
  methods: {
    getSetup() {
      return this.setup;
    },
    setSetup(setup) {
      return (this.setup = setup);
    },
  },
};
</script>
